/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FieldType = {
    STRING: 'STRING',
    NUMBER: 'NUMBER',
    BOOLEAN: 'BOOLEAN',
    OPTIONS: 'OPTIONS'
} as const;
export type FieldType = typeof FieldType[keyof typeof FieldType];


export function instanceOfFieldType(value: any): boolean {
    for (const key in FieldType) {
        if (Object.prototype.hasOwnProperty.call(FieldType, key)) {
            if (FieldType[key as keyof typeof FieldType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FieldTypeFromJSON(json: any): FieldType {
    return FieldTypeFromJSONTyped(json, false);
}

export function FieldTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldType {
    return json as FieldType;
}

export function FieldTypeToJSON(value?: FieldType | null): any {
    return value as any;
}

export function FieldTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FieldType {
    return value as FieldType;
}

